import { Button, Table } from "react-bootstrap";
import currency from "currency.js";
import CloseIcon from "mdi-react/CloseIcon";
import { formatDate, formatForQty } from "../../../utils/helpers";

export default function DamageRequestTable({ items = [], onRemove }) {
  return (
    <Table borderless striped className="product-table">
      <thead>
        <tr>
          <th />
          <th>S/N</th>
          <th>Item Name</th>
          <th>Batch</th>
          <th>ATC Code</th>
          <th>Unit Cost</th>
          <th>Available Qty</th>
          <th>Expiry Date</th>
          <th>Qty to Damage</th>
        </tr>
      </thead>
      <tbody>
        {items.length === 0 ? (
          <tr>
            <td colSpan={9} className="text-center py-3">
              No items added yet
            </td>
          </tr>
        ) : (
          items.map((el, index) => (
            <tr key={`${el.batchBarCode}-${index}`}>
              <td>
                <Button
                  variant=""
                  size="sm"
                  className="text-danger"
                  onClick={() => onRemove(index)}
                >
                  <CloseIcon size={16} />
                </Button>
              </td>
              <td>{index + 1}</td>
              <td>{el.itemName}</td>
              <td>
                {el.batchBarCode ? el.batchBarCode.split("-").pop() : "..."}{" "}
                {el.batchName ? <i>({el.batchName})</i> : null}
              </td>
              <td>{el.atcCode || "..."}</td>
              <td>
                {currency(el.unitCost, {
                  precision: 2,
                  symbol: "",
                }).format()}
              </td>
              <td>
                {currency(el.availableQuantity, {
                  precision: 2,
                  format: formatForQty,
                  symbol: "",
                }).format()}
              </td>
              <td className="text-nowrap">
                {el.expireDate ? formatDate(el.expireDate, "dd MMM, yyyy") : "..."}
              </td>
              <td>
                {currency(el.quantity, {
                  precision: 2,
                  format: formatForQty,
                  symbol: "",
                }).format()}
              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );
}
